var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMenuLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m24.323 20.036-3.86.007-2.764-3.649a1.205 1.205 0 0 1 .313-1.743 1.17 1.17 0 0 1 .623-.181l5.252-.005a1.17 1.17 0 0 1 .938.468l1.204 1.59c1.087 1.436.08 3.51-1.706 3.513Z",
  fill: "url(#MenuLogo_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.75 26.601h-.012l-17.22.016c-1.13.001-1.616-1.45-.72-2.147l5.439-4.233a1.17 1.17 0 0 1 .717-.248l10.53-.01 3.86-.006c1.784-.003 2.791-2.08 1.705-3.516l.375.495c2.98 3.94.218 9.635-4.674 9.65Z",
  fill: "#0894E4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m7.942 12.18 3.86-.006 2.763 3.649a1.205 1.205 0 0 1-.313 1.743c-.187.118-.402.18-.623.181l-5.251.005a1.169 1.169 0 0 1-.938-.468l-1.205-1.591c-1.086-1.435-.079-3.51 1.707-3.512Z",
  fill: "url(#MenuLogo_svg__b)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.491 5.516h.013l17.15-.016c1.125-.001 1.61 1.45.718 2.147l-5.418 4.233c-.205.16-.456.248-.714.248l-10.488.01-3.844.006c-1.777.003-2.78 2.08-1.698 3.516l-.373-.495c-2.968-3.94-.218-9.635 4.654-9.65Z",
  fill: "#27AE60"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "MenuLogo_svg__a",
  x1: 25.187,
  y1: 23.786,
  x2: 18.835,
  y2: 10.079,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.162,
  stopColor: "#631A13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#D74F3C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "MenuLogo_svg__b",
  x1: 7.658,
  y1: 11.843,
  x2: 12.059,
  y2: 17.965,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.162,
  stopColor: "#631A13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.981,
  stopColor: "#D74F3C"
})))));
export default SvgMenuLogo;